export default {"src":"/_next/static/media/icon_circle_checkmark.373d7aa3.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};